// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/:slug`
  | `/:slug/applications`
  | `/:slug/applications/:applicationId`
  | `/:slug/applications/new`
  | `/:slug/details`
  | `/:slug/profile`
  | `/:slug/profile/account`
  | `/:slug/profile/address`
  | `/:slug/profile/documents`
  | `/:slug/transactions`
  | `/:slug/transactions/:transactionId`
  | `/:slug/transactions/new`
  | `/:slug/users`
  | `/:slug/users/:userId`
  | `/:slug/users/:userId/account`
  | `/:slug/users/:userId/address`
  | `/:slug/users/:userId/contact`
  | `/:slug/users/:userId/documents`
  | `/:slug/users/:userId/transactions`
  | `/:slug/users/new`

export type Params = {
  '/:slug': { slug: string }
  '/:slug/applications': { slug: string }
  '/:slug/applications/:applicationId': { slug: string; applicationId: string }
  '/:slug/applications/new': { slug: string }
  '/:slug/details': { slug: string }
  '/:slug/profile': { slug: string }
  '/:slug/profile/account': { slug: string }
  '/:slug/profile/address': { slug: string }
  '/:slug/profile/documents': { slug: string }
  '/:slug/transactions': { slug: string }
  '/:slug/transactions/:transactionId': { slug: string; transactionId: string }
  '/:slug/transactions/new': { slug: string }
  '/:slug/users': { slug: string }
  '/:slug/users/:userId': { slug: string; userId: string }
  '/:slug/users/:userId/account': { slug: string; userId: string }
  '/:slug/users/:userId/address': { slug: string; userId: string }
  '/:slug/users/:userId/contact': { slug: string; userId: string }
  '/:slug/users/:userId/documents': { slug: string; userId: string }
  '/:slug/users/:userId/transactions': { slug: string; userId: string }
  '/:slug/users/new': { slug: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
